module.exports = __webpack_public_path__ + "img/paper1.834d5ca6.png";